import {
  SplitSessionCookieKey,
  createClientCookieValue,
  parseConsentCookie,
  readCookieValue,
  setDocumentCookie,
} from '@smg-real-estate/vue-experiments';

export const setTemporaryUUIDCookie = (
  splitSessionKey: string,
  documentCookie: string,
  locationHref: string,
): void => {
  const consentCookieValue = readCookieValue(documentCookie, 'OptanonConsent');
  const consentCookie = parseConsentCookie(consentCookieValue);
  if (!consentCookie?.groups.includes('C0002:1')) {
    return;
  }

  const cookieDomain = new URL(locationHref).host.split('.').slice(1).join('.');
  const tuuidCookie = `${createClientCookieValue(
    SplitSessionCookieKey.TEMP_SPLIT_SESSION_COOKIE_KEY,
    splitSessionKey,
  )} domain=.${cookieDomain}; secure; SameSite=None;`;
  setDocumentCookie(tuuidCookie);
};
